import { ICollection } from '@common/interfaces/collection.interface';
import { createCollection } from '@common/utils/create-collection.util';
import { useQuery, UseQueryResult } from 'react-query';
import { IDayRangeDto } from '../model/day-range.dto';

const NAME = 'mock-';

const useGetSystemHolidays = (): UseQueryResult<ICollection<IDayRangeDto>, void> => {
    return useQuery(`${NAME}-get-holidays`, () => {
        return Promise.resolve(
            createCollection(
                [
                    {
                        id: 'range1',
                        startDate: new Date('2021-11-10'),
                        endDate: new Date('2021-11-13'),
                    },
                ],
                0,
                {},
            ),
        );
    });
};

export const mock = {
    useGetSystemHolidays,
};
